import AOS from 'aos';

const aosSetup = () => {
	AOS.init({
		startEvent: 'load',
		once: true,
		duration: 1200,
		delay: 400,
	});
};

export default aosSetup;



// WEBPACK FOOTER //
// ./src/js/aos-config.js